import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
// import { FaStar } from 'react-icons/fa'; 
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import 'sweetalert2/dist/sweetalert2.min.css';

const Cex = ({ showHeader = true }) => {
  const [transactions, setTransactions] = useState([]);
  const [favorites, setFavorites] = useState([]); // store favorite IDs
  const [showFavoritesOnly, setShowFavoritesOnly] = useState(false);
  const [loading, setLoading] = useState(true);

   const dummyTransactions = [
    {
      _id: '1',
      hash: '0xabc1234567890',
      chainId: 1,
      type: 'deposit',
      from: 'binance-wallet-1',
      to: '0xuserwallet123',
      value: '0.75',
      symbol: 'ETH',
      transactionUrl: 'https://etherscan.io/tx/0xabc1234567890',
      transactionFee: '0',
      valueUSD: '2400',
    },
    {
      _id: '2',
      hash: '0xdef9876543210',
      chainId: 137,
      type: 'withdrawal',
      from: '0xuserwallet456',
      to: 'kucoin-wallet-3',
      value: '1200',
      symbol: 'USDT',
      transactionUrl: 'https://polygonscan.com/tx/0xdef9876543210',
      transactionFee: '1.5',
      valueUSD: '1200',
    },
    {
      _id: '3',
      hash: '0x9876fedcba543',
      chainId: 56,
      type: 'trade',
      from: 'user123@coinbase',
      to: 'user123@coinbase',
      value: '0.1',
      symbol: 'BTC',
      transactionUrl: 'https://bscscan.com/tx/0x9876fedcba543',
      transactionFee: '0.0005',
      valueUSD: '6500',
    },
    {
      _id: '4',
      hash: '0xa1b2c3d4e5f6',
      chainId: 43114,
      type: 'deposit',
      from: 'okx-fund-wallet',
      to: '0xwalletabc456',
      value: '300',
      symbol: 'AVAX',
      transactionUrl: 'https://snowtrace.io/tx/0xa1b2c3d4e5f6',
      transactionFee: '0',
      valueUSD: '3300',
    },
    {
      _id: '5',
      hash: '0xfeedfaceb00c',
      chainId: 137,
      type: 'withdrawal',
      from: '0xwalletxyz123',
      to: 'crypto-com-wallet-2',
      value: '100',
      symbol: 'MATIC',
      transactionUrl: 'https://polygonscan.com/tx/0xfeedfaceb00c',
      transactionFee: '0.01',
      valueUSD: '90',
    },
    {
      _id: '6',
      hash: '0x998877665544',
      chainId: 1,
      type: 'trade',
      from: 'kraken-exchange',
      to: 'kraken-exchange',
      value: '2',
      symbol: 'ETH',
      transactionUrl: 'https://etherscan.io/tx/0x998877665544',
      transactionFee: '0.002',
      valueUSD: '6200',
    },
    {
      _id: '7',
      hash: '0x12344321abcd',
      chainId: 56,
      type: 'deposit',
      from: 'huobi-main-wallet',
      to: '0xuserdepositwallet',
      value: '500',
      symbol: 'BNB',
      transactionUrl: 'https://bscscan.com/tx/0x12344321abcd',
      transactionFee: '0',
      valueUSD: '170000',
    },
    {
      _id: '8',
      hash: '0xdeadbeef1234',
      chainId: 43113,
      type: 'withdrawal',
      from: '0xmywallet555',
      to: 'bitfinex-vault-1',
      value: '50',
      symbol: 'AVAX',
      transactionUrl: 'https://testnet.snowtrace.io/tx/0xdeadbeef1234',
      transactionFee: '0.05',
      valueUSD: '540',
    },
    {
      _id: '9',
      hash: '0x001122334455',
      chainId: 137,
      type: 'deposit',
      from: 'gemini-deposit-1',
      to: '0xwallet001',
      value: '3000',
      symbol: 'USDC',
      transactionUrl: 'https://polygonscan.com/tx/0x001122334455',
      transactionFee: '0',
      valueUSD: '3000',
    },
    {
      _id: '10',
      hash: '0xaa55cc33ee77',
      chainId: 56,
      type: 'withdrawal',
      from: '0xwallet998',
      to: 'crypto-com-main',
      value: '250',
      symbol: 'BUSD',
      transactionUrl: 'https://bscscan.com/tx/0xaa55cc33ee77',
      transactionFee: '0.25',
      valueUSD: '250',
    },
    {
      _id: '11',
      hash: '0xfafafafafa01',
      chainId: 1,
      type: 'trade',
      from: 'binance-internal',
      to: 'binance-internal',
      value: '0.25',
      symbol: 'ETH',
      transactionUrl: 'https://etherscan.io/tx/0xfafafafafa01',
      transactionFee: '0.0003',
      valueUSD: '800',
    },
    {
      _id: '12',
      hash: '0xbeef1234abcd',
      chainId: 80002,
      type: 'deposit',
      from: 'exchange-fake-wallet',
      to: '0xfakewallet123',
      value: '10',
      symbol: 'MATIC',
      transactionUrl: 'https://amoy.polygonscan.com/tx/0xbeef1234abcd',
      transactionFee: '0',
      valueUSD: '8.5',
    },
    {
      _id: '13',
      hash: '0x112233445566',
      chainId: 43114,
      type: 'withdrawal',
      from: '0xwallet420',
      to: 'exchange-mainnet-vault',
      value: '75',
      symbol: 'AVAX',
      transactionUrl: 'https://snowtrace.io/tx/0x112233445566',
      transactionFee: '0.07',
      valueUSD: '825',
    },
    {
      _id: '14',
      hash: '0x776655443322',
      chainId: 137,
      type: 'deposit',
      from: 'bitmart-deposit-4',
      to: '0xwallet006',
      value: '750',
      symbol: 'MATIC',
      transactionUrl: 'https://polygonscan.com/tx/0x776655443322',
      transactionFee: '0',
      valueUSD: '675',
    },
    {
      _id: '15',
      hash: '0xccccbbbbdddd',
      chainId: 56,
      type: 'withdrawal',
      from: '0xwallet123xyz',
      to: 'binance-hotwallet',
      value: '300',
      symbol: 'BNB',
      transactionUrl: 'https://bscscan.com/tx/0xccccbbbbdddd',
      transactionFee: '0.3',
      valueUSD: '102000',
    },
    {
      _id: '16',
      hash: '0xdeadbeefbeef',
      chainId: 43114,
      type: 'trade',
      from: 'kraken-internal',
      to: 'kraken-internal',
      value: '0.02',
      symbol: 'BTC',
      transactionUrl: 'https://snowtrace.io/tx/0xdeadbeefbeef',
      transactionFee: '0.0001',
      valueUSD: '1200',
    },
    {
      _id: '17',
      hash: '0xabcdefabcdef',
      chainId: 1,
      type: 'deposit',
      from: 'coinbase-funding',
      to: '0xwalletcoinbase123',
      value: '1.5',
      symbol: 'ETH',
      transactionUrl: 'https://etherscan.io/tx/0xabcdefabcdef',
      transactionFee: '0',
      valueUSD: '4500',
    },
    {
      _id: '18',
      hash: '0x111111111111',
      chainId: 137,
      type: 'withdrawal',
      from: '0xwalletwithdraw99',
      to: 'okx-wallet-10',
      value: '800',
      symbol: 'USDT',
      transactionUrl: 'https://polygonscan.com/tx/0x111111111111',
      transactionFee: '1',
      valueUSD: '800',
    },
    {
      _id: '19',
      hash: '0x222222222222',
      chainId: 56,
      type: 'trade',
      from: 'bitget-trade-hub',
      to: 'bitget-trade-hub',
      value: '0.5',
      symbol: 'BTC',
      transactionUrl: 'https://bscscan.com/tx/0x222222222222',
      transactionFee: '0.0004',
      valueUSD: '32500',
    },
    {
      _id: '20',
      hash: '0x333333333333',
      chainId: 43113,
      type: 'deposit',
      from: 'mock-exchange-vault',
      to: '0xwalletdevnet',
      value: '200',
      symbol: 'AVAX',
      transactionUrl: 'https://testnet.snowtrace.io/tx/0x333333333333',
      transactionFee: '0',
      valueUSD: '2100',
    },
  ];
  

  const copyToClipboard = (text) => {
    const input = document.createElement("input");
    input.value = text;
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);

    Swal.fire({
      toast: true,
      position: "top-end",
      icon: "success",
      title: "Copied to clipboard!",
      showConfirmButton: false,
      timer: 2000,
      background: "#be6bed",
      color: "#fff",
    });
  };

  const chainIds = {
    1: "Ethereum",
    11155111: "Sepolia",
    101: "Solana Mainnet",
    103: "Solana devnet",
    80002: "Polygon Amoy",
    137: "Polygon",
    56: "Binance",
    97: "Binance Testnet",
    43114: "Avalanche Mainnet",
    43113: "Avalanche Fuji"
  };

  const toggleFavorite = (id) => {
    setFavorites((prev) =>
      prev.includes(id)
        ? prev.filter((favId) => favId !== id)
        : [...prev, id]
    );

    // Simulate API call
    mockFavoriteApiCall(id);
  };

  const mockFavoriteApiCall = (id) => {
    console.log(`Toggled favorite for transaction ID: ${id}`);
    // You can replace this with a real API call using fetch or axios
  };

  useEffect(() => {
    setTimeout(() => {
      setTransactions(dummyTransactions);
      setLoading(false);
    }, 1000);
  }, []);

  const filteredTransactions = showFavoritesOnly
    ? transactions.filter((txn) => favorites.includes(txn._id))
    : transactions;

  return (
    <div className="newpool-back">
      {showHeader && (
        <div className="header-container">
          <div className="header-content">
            <h2 className="header-subtitle">
              FIND YOUR<span className="color-sp"> IDEAL INVESTMENT </span>VAULT
              <span className="color-sp"> Centralized Exchange</span>
            </h2>
            <p className="header-description">
              Explore diverse investment opportunities—from automated tools to personalized strategies—all in one secure, centralized platform
            </p>
          </div>
          <div className="details-borders"></div>
        </div>
      )}

      <div style={{ margin: "10px 20px" }}>
        <button
          onClick={() => setShowFavoritesOnly((prev) => !prev)}
          style={{
            backgroundColor: showFavoritesOnly ? "#be6bed" : "#be6bed",
            color: "#fff",
            padding: "8px 16px",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            background : "#be6bed",
          }}
        >
          {showFavoritesOnly ? "Show All Transactions" : "Show Favorites"}
        </button>
      </div>

      <div className="table-container-new custom-scrollbar">
        <table className="table-table-container">
          <thead className="active-header">
            <tr>
              <th>   <FaHeart color="#e25555" /></th>
              <th>Hash</th>
              <th>Chain</th>
              <th>Type</th>
              <th>From</th>
              <th>To</th>
              <th>Value</th>
              <th>Symbol</th>
              <th>Link</th>
              <th>Transaction Fee</th>
              <th style={{ textAlign: "center" }}>Value USD</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              Array.from({ length: 20 }).map((_, index) => (
                <tr key={index}>
                  {Array.from({ length: 11 }).map((_, cellIndex) => (
                    <td key={cellIndex}>
                      <div className="skeleton skeleton-text"></div>
                    </td>
                  ))}
                </tr>
              ))
            ) : (
              filteredTransactions.map((txn) => (
                <tr key={txn._id}>
               <td
  style={{ textAlign: "center", cursor: "pointer" }}
  onClick={() => toggleFavorite(txn._id)}
>
  {favorites.includes(txn._id) ? (
   <FaHeart color="#e25555" style={{ marginTop: '12px' }} />

  ) : (
    <FaRegHeart color="#aaa" style={{ marginTop: '12px' }}/>
  )}
</td>
                  <td
                    className="coin-name-cell"
                    style={{ cursor: "pointer", color: "#be6bed" }}
                    onClick={() => copyToClipboard(txn.hash)}
                    title="Click to copy hash"
                  >
                   
                  </td>
                  <td> {txn.hash?.slice(0, 10)}...</td>
                  <td>{chainIds[txn.chainId]}</td>
                  <td>{txn.type}</td>
                  <td title={txn.from} style={{ cursor: "pointer", color: "#be6bed" }} onClick={() => copyToClipboard(txn.from)}>
                    {txn.from?.slice(0, 6)}...{txn.from?.slice(-4)}
                  </td>
                  <td title={txn.to} style={{ cursor: "pointer", color: "#be6bed" }} onClick={() => copyToClipboard(txn.to)}>
                    {txn.to?.slice(0, 6)}...{txn.to?.slice(-4)}
                  </td>
                  <td>{txn.value}</td>
                  <td>{txn.symbol}</td>
                  <td>
                    <a
                      style={{ color: "#be6bed" }}
                      href={txn.transactionUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      View
                    </a>
                  </td>
                  <td style={{ textAlign: "center" }}>{txn.transactionFee}</td>
                  <td style={{ textAlign: "center" }}>{txn.valueUSD || 0}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Cex;
